import categoryMapping from "@/data/categoryMapping";
import categoryGrouping from "@/data/categoryGrouping";

export default {
    user: function (userStore) {
        let userItems = [
            {
                name: "My Account",
                to: {name: "accountDashboard"},
                icon: "fa fa-user",
            },
            {
                name: "New Site",
                to: {name: "newSite"},
                icon: "fa fa-plus",
            },
            {
                name: "API Keys",
                to: {name: "keys"},
                icon: "fa fa-key",
            },
            {
                name: "Billing",
                heading: true,
            },

        ]

        userItems.push(
            {
                name: "Subscription",
                to: {name: "subscription"},
                icon: "fa fa-dollar-sign",
            }
        )


        return userItems
    },
    main: function (websiteStore) {
        let website = websiteStore.website;
        if (!website) {
            return []
        }

        let auditMenu = [];
        let spellingSub = [{
            name: 'Summary',
            to: {name: 'spelling.summary'},
            icon: "",
        }]
        let dividerAdded = false;
        for (let category of categoryGrouping.proofread.innerCategories) {
            if (websiteStore.getIssueCount(category) > 0) {
                const [cat, detail] = category.split(/\.(.+)/);
                if (!dividerAdded) {
                    spellingSub.push({separator: true});
                    dividerAdded = true;
                }
                spellingSub.push({
                    name: categoryMapping[cat][detail]['label'],
                    to: {name: categoryMapping[cat][detail]['name']},
                    icon: "",
                })
            }
        }

        let ciSub = [{
            name: 'Summary',
            to: {name: 'integrity.summary'},
            icon: "",
        }]
        dividerAdded = false;
        for (let category of categoryGrouping.integrity.innerCategories) {
            if (websiteStore.getIssueCount(category) > 0) {
                const [cat, detail] = category.split(/\.(.+)/);
                if (!dividerAdded) {
                    ciSub.push({separator: true});
                    dividerAdded = true;
                }
                ciSub.push({
                    name: categoryMapping[cat][detail]['label'],
                    to: {name: categoryMapping[cat][detail]['name']},
                    icon: "",
                })
            }
        }

        let technicalSub = [{
            name: 'Summary',
            to: {name: 'technical.summary'},
            icon: "",
        }]
        dividerAdded = false;
        for (let category of categoryGrouping.technical.innerCategories) {
            if (websiteStore.getIssueCount(category) > 0) {
                const [cat, detail] = category.split(/\.(.+)/);
                if (!dividerAdded) {
                    technicalSub.push({separator: true});
                    dividerAdded = true;
                }
                technicalSub.push({
                    name: categoryMapping[cat][detail]['label'],
                    to: {name: categoryMapping[cat][detail]['name']},
                    icon: "",
                })
            }
        }

        auditMenu.push({
            name: `Technical Issues`,
            icon: categoryGrouping.technical.icon,
            subActivePaths: "/r/:websiteId/technical",
            sub: technicalSub
        })

        let layoutSub = [{
            name: 'Summary',
            to: {name: 'layout.summary'},
            icon: "",
        }]
        dividerAdded = false;
        for (let category of categoryGrouping.layout.innerCategories) {
            if (websiteStore.getIssueCount(category) > 0) {
                const [cat, detail] = category.split(/\.(.+)/);
                if (!dividerAdded) {
                    layoutSub.push({separator: true});
                    dividerAdded = true;
                }
                layoutSub.push({
                    name: categoryMapping[cat][detail]['label'],
                    to: {name: categoryMapping[cat][detail]['name']},
                    icon: "",
                })
            }
        }
        auditMenu.push({
            name: `Layout Issues`,
            icon: categoryGrouping.layout.icon,
            subActivePaths: "/r/:websiteId/layout",
            sub: layoutSub
        });

        let menuItems = [
            {
                name: "Dashboard",
                to: {name: "dashboard"},
                icon: "si si-home",
            },
        ]

        menuItems = menuItems.concat([
            {
                name: "Explore",
                heading: true,
            },
            {
                name: "All Pages",
                to: {name: "explore"},
                icon: "fa fa-eye",
            },
            {
                name: "Timeline",
                to: {name: "timeline"},
                icon: "fa fa-clock-rotate-left",
            },
        ]);

        menuItems = menuItems.concat([
            {
                name: "Proofreading",
                heading: true,
            },
            {
                name: `Spelling/Grammar`,
                icon: categoryGrouping.proofread.icon,
                subActivePaths: "/r/:websiteId/spelling",
                sub: spellingSub
            },
            {
                name: `Content Integrity`,
                icon: categoryGrouping.integrity.icon,
                subActivePaths: "/r/:websiteId/integrity",
                sub: ciSub
            },


        ]);

        if (auditMenu.length > 0) {
            menuItems = menuItems.concat([
                {
                    name: "Audit",
                    heading: true,
                },
            ]);
            menuItems = menuItems.concat(auditMenu);
        }
        menuItems = menuItems.concat([
            {
                name: "AI Checks",
                heading: true,
            },

            {
                name: `AI Readiness`,
                icon: categoryGrouping.ai_readiness.icon,
                to: {name: 'ai.summary'},

            },
            {
                name: `Watched Prompts`,
                icon: categoryGrouping.qa.icon,
                to: {name: 'ai.prompts'},
            },
        ]);

        return menuItems;

    }
    ,
}
;
